import React, { useState, useEffect } from 'react'
import { Panel, Message, Table, Row, Col, ControlLabel, Input, Form } from 'rsuite'
import { getProjectOverview } from '../../../redux/actions/projectOverview'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'

export default function ProjectInfoWidget(props) {
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShaded, setIsShaded] = useState(props.shaded)
  const [info, setInfo] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    try {
      const _schema = await getProjectOverview(formSchema.projectId)

      _schema.forms.projectInfo.projectBasicInfoHeader = 'ข้อมูลโครงการ'
      setInfo(_schema.forms.projectInfo)
    } catch (e) {
      console.log('e', e)
    }
  }

  return <>{info && <ProjectBasicInfo schema={info} shaded={false} />}</>
}
